import { render, staticRenderFns } from "./ElePage.vue?vue&type=template&id=0acf601b&scoped=true"
import script from "./ElePage.vue?vue&type=script&lang=js"
export * from "./ElePage.vue?vue&type=script&lang=js"
import style0 from "./ElePage.vue?vue&type=style&index=0&id=0acf601b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf601b",
  null
  
)

/* custom blocks */
import block0 from "./ElePage.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports